<div *ngIf="auction?.prebidConfiguration?.__config__" provide-parent-form>
	
	<bb-collapsible [title]="'GENERAL' | translate" togglePosition="before" theme="uui" [startOpen]="true" [description]="'HELP.AUCTION_GENERAL' | translate">
		<bb-form-element [form]="form" invalidMessage="Name is required" [label]="'NAME' | translate">
			<bb-text [(ngModel)]="auction.name" required (ngModelChange)="onNameUpdated($event)" name="auction_name">
			</bb-text>
		</bb-form-element>

		<bb-form-element [form]="form" [label]="'CODE' | translate">
			<bb-text [class.disabled]="!isNew" [(ngModel)]="auction.code" (ngModelChange)="updateCode($event)"
				name="code"></bb-text>
		</bb-form-element>

		<bb-form-element [form]="form" [label]="'AD_SERVER_URL' | translate">
			<bb-text [(ngModel)]="auction.adServerUrl" [placeholder]="'LEAVE_EMPTY_TO_DIRECTLY_USE_WINNING_BID' | translate" name="auction_adServerUrl">
			</bb-text>
		</bb-form-element>
	</bb-collapsible>
	<hr />

	<bb-auction-settings [form]="form" [config]="auction.prebidConfiguration.__config__"></bb-auction-settings>
</div>
